"use strict";

import './../../../../js/vue-components/autocomplete-cities';
import './../../../../js/vue-components/autocomplete-labs';

(function(window, $) {

	let url = window.location.href;

	function parseURL(url) {
		var parser = document.createElement('a'),
			searchObject = {},
			queries,
			split,
			i;
		// Let the browser do the work
		parser.href = url;
		// Convert query string to object
		queries = parser.search.replace(/^\?/, '').split('&');
		for (i = 0; i < queries.length; i++) {
			split = queries[i].split('=');
			searchObject[split[0]] = split[1];
		}
		return {
			protocol: parser.protocol,
			host: parser.host,
			hostname: parser.hostname,
			port: parser.port,
			pathname: parser.pathname,
			search: parser.search,
			searchObject: searchObject,
			hash: parser.hash
		};
	}

	let router = new VueRouter({
		mode: 'history',
		routes: [
			{path: '/'},
			{path: '/labs-and-you/labs'},
			{path: '/hi/shawn'},
		]
	});

	Vue.component('vue-member-labs', {

		template: `
			<div class="member-labs">
			
			<div class="map-search-filters">
				<div class="container">
				
					<form class="flex-container">
					
						<div class="search-inputs">
						
							<div class="prov-filter">
								<select class="form-select prov-filter-box" @change="searchFilter" v-model="province" selected="selected">
									<option disabled hidden value="null">Filter by Province</option>
									<option value="all">All</option>
									<option value="AB">Alberta</option>
									<option value="BC">British Columbia</option>
									<option value="MB">Manitoba</option>
									<option value="NB">New Brunswick</option>
									<option value="NL">Newfoundland</option>
									<option value="NS">Nova Scotia</option>
									<option value="SK">Saskatchewan</option>
									<option value="ON">Ontario</option>
									<option value="PE">Prince Edward Island</option>
									<option value="QC">Quebec</option>
									<option value="WA">Washington</option>
									<option value="YT">Yukon Territory</option>
									all
								</select>
							</div>
			
							<div class="division-filter">
							 <select class="form-select division-filter-box" @change="searchFilter" v-model="division" selected="selected">
									<option disabled hidden value="null">Filter by Division</option>
									<option value="A">All</option>
									<option v-for="divisionOption in divisionsArray" :value="divisionOption.slug">{{divisionOption.name}}</option>
							 </select>
							</div>
							
							<div class="city-filter">
								<autocomplete-cities v-model="city" :cities="citiesArray" @searchCity="searchFilter" ref="autoCompCity"></autocomplete-cities>
							</div>
							
							<div class="name-filter">
								<autocomplete-labs v-model="name" :names="namesArray" @searchName="searchFilter" ref="autoCompLab"></autocomplete-labs>
							</div>
						
						</div>
						
						<button 
							class="btn btn-secondary btn-circle" 
							type="button" 
							ref="search-filter" 
							@searchFilter="searchFilter" 
							@click="searchFilter"
						>
							<span class="sr-only">Search</span>
							<img :src="searchIcon" />
						</button>
					 
					</form>
					
				</div>
			</div>
			
			<div class="container">
			
				<div class="top-details">
					<div class="paginator-details">
						<span v-if="lastPage == currentPage + 1">Showing {{(10 * currentPage) + 1}} - {{(10 * currentPage) + visibleCards.length}} of {{cardLabs.length}} results</span>
						<span v-else>Showing {{(10 * currentPage) + 1}} - {{visibleCards.length * (currentPage + 1)}} of {{cardLabs.length}} results</span>
					</div>
				</div>
			
				<div class="member-cards">
					<member-cards 
						v-for="lab in visibleCards" 
						:lab="lab" 
						:key="lab.id"
						:pin-red="pinRed"
						pin-dark="pinDark"
					/>
				</div>

				<div class="last-page-count">
					<span v-if="lastPage == currentPage + 1">Showing {{(10 * currentPage) + 1}} - {{(10 * currentPage) + visibleCards.length}} of {{cardLabs.length}} results</span>
					<span v-else>Showing {{(10 * currentPage) + 1}} - {{visibleCards.length * (currentPage + 1)}} of {{cardLabs.length}} results</span>
				</div>
				
			</div>
			
			<div class="pagination-center-wrapper">
				<nav>
					<ul class="pagination">
					
						<li 
							class="page-item page-link page-previous" 
							@click="prevClick"
							:class="(currentPage + 1 == firstPage) ? 'disabled' : ''"
						>
							<span class="sr-only">Previous</span>
						</li>
						
						<li 
							@click="pageNumberClick(firstPage)" 
							class="page-item page-link"
							:class="(currentPage + 1 == firstPage) ? 'active' : ''"
						>
							{{firstPage}}
						</li>
						
						<li 
							v-if="currentPageDummy >= 6 && currentPageDummy < lastPage + 6" 
							@click="pageJumpBack" 
							class="page-item page-link"
						>...</li>
						
						<li 
							v-for="(page, index) in visiblePages" 
							v-if="firstPage != page && lastPage != page" 
							@click="pageNumberClick(page)" 
							class="page-item page-link"
							:class="((currentPage + 1) == page) ? 'active' : ''"
						>
							{{page}}
						</li>
						
						<li 
							v-if="currentPageDummy <= lastPage - 4" 
							@click="pageJumpForward" 
							class="page-item page-link"
						>...</li>
						
						<li 
							@click="pageNumberClick(lastPage)" 
							v-if="lastPage != firstPage" 
							class="page-item page-link"
							:class="(currentPage + 1 == lastPage) ? 'active' : ''"
						>
							{{lastPage}}
						</li>
						
						<li 
							class="page-item page-link page-next" 
							@click="nextClick"
							:class="(currentPage + 1 == lastPage) ? 'disabled' : ''"
						>
							<span class="sr-only">Next</span>
						</li>
						
					</ul>
				</nav>
			</div>
			
			</div>
		`,

		data() {
			return {
				pinRed: '',
				pinDark: '',
				searchIcon: '',
				citiesArray: [],
				namesArray: [],
				provincesArray: {
					'AB': 'Alberta',
					'BC': 'British Columbia',
					'MB': 'Manitoba',
					'NB': 'New Brunswick',
					'NL': 'Newfoundland',
					'NS': 'Nova Scotia',
					'SK': 'Saskatchewan',
					'ON': 'Ontario',
					'PE': 'Prince Edward Island',
					'QC': 'Quebec',
					'WA': 'Washington',
					'YT': 'Yukon'
				},
				provCoords: {
					'AB': {
						lat: 55.605328,
						lng: -115.255760
					},
					"BC": {
						lat: 55.329158,
						lng: -125.311272
					},
					'MB': {
						lat: 55.107110,
						lng: -97.336523
					},
					'NB': {
						lat: 46.461672,
						lng: -64.736573
					},
					'NL': {
						lat: 51.721480,
						lng: -55.914697
					},
					'NS': {
						lat: 45.401723,
						lng: -63.184727
					},
					'SK': {
						lat: 54.497455,
						lng: -105.828935
					},
					'ON': {
						lat: 48.991912,
						lng: -82.712002
					},
					'PE': {
						lat: 46.510712,
						lng: -63.416814
					},
					'QC': {
						lat: 49.764029,
						lng: -73.948482
					},
					'WA': {
						lat: 47.595759,
						lng: -120.025973
					},
					'YT': {
						lat: 64.011436,
						lng: -135.644704
					}
				},
				code: null,
				labsTemp: [],
				labs: [],
				center: {
					lat: 51.508,
					lng: -91.587
				},
				zoom: 4.5,
				markers: [],
				memberMarkers: [],
				province: null,
				program: null,
				membership: null,
				divisionsArray: [],
				division: null,
				hideFilter: [],
				city: null,
				name: null,
				places: [],
				cardLabs: [],
				cardLabsMin: [],
				currentPlace: null,
				addressHolder: [],
				firstPage: 1,
				currentPage: 0,
				currentPageDummy: 0,
				pageSize: 10,
				pagesArray: [],
				visibleCards: [],
				visiblePages: [],
				infoPosition: null,
				infoAddress: null,
				infoName: null,
				infoOpened: false,
				infoCurrentKey: null,
				infoOptions: {
					pixelOffset: {
						width: 0,
						height: -35
					}
				},
				paginate: ['cards']
			}
		},

		mounted: function () {

			let prot = 'https://';
			let self = this;
			let base = parseURL(url).hostname;

			if (base == 'cciweb.local') {
				prot = 'http://';
			}
			let assetsURL = prot + base + '/wp-content/themes/ccil-web-2026/assets';
			this.pinRed = assetsURL + '/pin-red.svg';
			this.pinDark = assetsURL + '/pin-dark.svg';
			this.searchIcon = assetsURL + '/search.svg';
			let baseURL = prot + base + '/wp-json/ccil/v1/labs';
			// console.log(baseURL);

			// TEMP
			//let baseURL = prot + base + '/wp-content/themes/ccil-web-2026/src/blocks/ccil-members-output/script/member_labs.json';

			const ax = axios.create({baseURL: baseURL});

			ax.get()
				.then(function (response) {
					console.log(response.data);
					self.labs = [];
					self.labsDataCMS = response.data;

					let existingSlugs = [];

					for (let labsCMSKey in self.labsDataCMS) {

						self.citiesArray.push(self.labsDataCMS[labsCMSKey].city);
						self.namesArray.push(self.labsDataCMS[labsCMSKey].name);
						for (let slug in self.labsDataCMS[labsCMSKey].divisions) {
							if (self.labsDataCMS[labsCMSKey].divisions.hasOwnProperty(slug) && !existingSlugs.includes(slug)) {
								existingSlugs.push(slug);
								self.divisionsArray.push({
									name: self.labsDataCMS[labsCMSKey].divisions[slug],
									slug: slug
								});
							}
						}
					}

					self.labs.push(...self.labsDataCMS);

					const citiesArray = self.citiesArray;
					self.citiesArray = self.uniqueify(citiesArray);
					self.currentPageDummy = self.currentPage;

					function sortByLabName(a, b) {
						var aName = a.name.toLowerCase();
						var bName = b.name.toLowerCase();
						return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
					}

					self.labs.sort(sortByLabName);

					self.cardLabs = self.labs;
					self.cardLabsMin = self.cardLabs.slice(0, 10);
					self.updateVisibleCards();

					for (var i = 1; i < (self.pageCount); i++) {
						self.pagesArray.push(i)
					}
					self.updateVisiblePages();

				});

		},

		computed: {

			sortedCities: function () {
				let self = this;

				function compare(a, b) {
					if (a < b)
						return -1;
					if (a > b)
						return 1;
					return 0;
				}

				return this.citiesArray.sort(compare);
			},

			pageCount: function () {
				return (Math.ceil(this.cardLabs.length / this.pageSize));
			},

			lastPage: function () {

				return (Math.ceil(this.cardLabs.length / this.pageSize))
			}

		},

		methods: {
			updateVisibleCards() {
				let self = this;
				if (self.cardLabs.length <= 0) {
					self.visibleCards = [];
					self.currentPageDummy = 0;
				} else {
					self.visibleCards = self.cardLabs.slice((self.currentPage * self.pageSize), (self.currentPage * self.pageSize) + self.pageSize);
					self.currentPageDummy = self.currentPage
				}

				self.updateVisiblePages();
			},
			updateVisiblePages() {
				let self = this;

				if (self.currentPageDummy < 4) {
					if (self.lastPage > 5) {
						self.visiblePages = self.pagesArray.slice(0, 5)
					} else {
						self.visiblePages = self.pagesArray.slice(0, self.lastPage - 1)
					}
				} else if (self.currentPageDummy > (self.lastPage - 2)) {
					self.visiblePages = self.pagesArray.slice((self.currentPageDummy - 7), (self.lastPage - 1))
				} else {
					self.visiblePages = self.pagesArray.slice((self.currentPageDummy - 4), (self.currentPageDummy + 2));
				}

				if (self.visibleCards.length == 0) self.visiblePages = 0;
			},
			updatePage(pageNumber) {
				let self = this;
				self.currentPage = pageNumber;
				self.updateVisibleCards();
			},
			setPlace(place) {
				this.currentPlace = place;
			},
			provinceClick() {
				let self = this;
				self.currentPage = 0;
				console.log(self);
				if (self.province === null) {
				} else {
					self.setProvince();
				}
			},
			nameClick() {
				let self = this;
				self.currentPage = 0;
				if (self.name === null) {
				} else {
					self.setName();
				}
			},
			divisionClick() {
				let self = this;
				self.currentPage = 0;
				if (self.division === null) {
				} else {
					self.setDivision();
				}
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			setDivision() {
				let self = this;
				self.infoOpened = false;
				self.$refs.autoCompLab.resetResult();
				self.cardLabsMin = [];
				self.cardLabs = [];
				self.markers = [];
				for (var key in self.labs) {

					if (typeof self.labs[key].divisions !== 'undefined' && typeof self.labs[key].divisions[self.division] !== 'undefined' || self.division === 'A') {

						let push = true;
						let newLab = self.labs[key];

						/* Checks other filters to combine */
						if (self.province && self.province !== 'all' && self.province !== []) {
							if (self.province !== newLab.addressParse[1]) {
								push = false;
							}
						}

						if (self.city) {
							if (self.city !== newLab.city) {
								push = false;
							}
						}
						/* Checks other filters to combine */

						if (push) {
							self.cardLabsMin.push(newLab);
							self.cardLabs.push(newLab);
						}

					}
				}
				self.updateVisibleCards();
			},
			setProvince() {
				let self = this;
				self.infoOpened = false;
				// if(self.province !== 'all'){
				self.$refs.autoCompCity.resetResult();
				self.$refs.autoCompLab.resetResult();
				self.city = null;
				self.cardLabsMin = [];
				self.cardLabs = [];
				for (var key in self.labs) {
					if (self.labs[key].addressParse[1] === self.province || self.province === 'all') {

						let push = true;
						let newLab = self.labs[key];

						if (self.division !== 'A' && self.division) {
							if (typeof newLab.divisions === 'undefined' || typeof newLab.divisions[self.division] === 'undefined') {
								push = false;
							}
						}

						if (push) {
							self.cardLabsMin.push(newLab);
							self.cardLabs.push(newLab);
						}

					}
				}
				self.updateVisibleCards();

			},
			setCity() {
				let self = this;
				self.currentPage = 0;
				self.infoOpened = false;
				if (self.city !== 'all') {
					self.$refs.autoCompLab.resetResult();
					self.cardLabsMin = [];
					self.cardLabs = [];
					for (var key in self.labs) {

						let branch = false;

						for (let branchKey in self.labs[key].branches) {
							let branchArray = self.labs[key].branches[branchKey].split(",");
							if (self.city === branchArray[0].toLowerCase()) {
								branch = true;
							}
						}

						if (self.labs[key].city === self.city || !self.city || branch) {

							let newLab = self.labs[key];
							var inProvince = false;
							let push = true;

							if (self.division !== 'A' && self.division) {
								if (typeof newLab.divisions === 'undefined' || typeof newLab.divisions[self.division] === 'undefined') {
									push = false;
								}
							}

							if (push) {

								if (self.province && self.province !== 'all' && self.province !== []) {
									if (self.province === newLab.addressParse[1]) {
										inProvince = true;
									}
								}

								self.cardLabsMin.push(newLab);
								self.cardLabs.push(newLab);

							}

						}
					}

					if (!inProvince) {
						self.province = null;
					}

					self.updateVisibleCards();
				}
			},
			setName() {
				let self = this;

				self.currentPage = 0;
				self.infoOpened = false;
				// if(self.name !== 'all'){
				self.$refs.autoCompCity.resetResult();
				self.province = null;
				self.division = null;
				self.cardLabsMin = [];
				self.cardLabs = [];

				if (self.name.length > 0) {
					for (var key in self.labs) {
						if (self.labs[key].name === self.name) {

							let newLab = self.labs[key];
							let push = true;

							if (self.division !== 'A' && self.division) {
								if (typeof newLab.divisions === 'undefined' || typeof newLab.divisions[self.division] === 'undefined') {
									push = false;
								}
							}

							if (push) {
								self.cardLabsMin.push(newLab);
								self.cardLabs.push(newLab);
							}
						}
					}
				} else {

					for (var key in self.labs) {

						self.cardLabsMin.push(self.labs[key]);
						self.cardLabs.push(self.labs[key]);

					}

				}

				self.updateVisibleCards();

			},
			searchFilter() {

				let self = this;

				self.cardLabsMin = [];
				self.cardLabs = [];
				self.currentPage = 0;

				for (let key in self.labs) {

					if (
						self.searchLab(self.labs[key]) &&
						self.searchProvince(self.labs[key]) &&
						self.searchCity(self.labs[key]) &&
						self.searchDivision(self.labs[key])
					) {
						self.cardLabsMin.push(self.labs[key]);
						self.cardLabs.push(self.labs[key]);
					}

				}

				self.updateVisibleCards();

			},
			searchProvince(lab) {

				let self = this,
					branch = false,
					re = new RegExp(self.provincesArray[self.province], 'gi');

				console.log(re);

				for (let branchKey in lab.branches) {

					let branchArray = lab.branches[branchKey].split(",");

					if (branchArray[1].match(re)) {
						branch = true;
						break;
					}

				}

				if (
					lab.addressParse[1] === self.province ||
					self.province === 'all' ||
					!self.province ||
					branch
				) {
					return true;
				}

				return false;

			},
			searchDivision(lab) {

				let self = this;

				if (
					self.division === 'A' ||
					typeof lab.divisions[self.division] !== 'undefined'
					|| !self.division
				) {
					return true;
				}

				return false;

			},
			searchCity(lab) {

				let self = this;
				let branch = false;
				let re = new RegExp(self.city, 'gi');

				console.log(lab.branches);
				console.log(re);


				for (let branchKey in lab.branches) {
					console.log(branchKey);
					let branchArray = lab.branches[branchKey].split(",");
					console.log(branchArray);
					if (branchArray[0].length > 0 && branchArray[0].match(re)) {
						branch = true;
						break;
					}

				}

				if (
					!self.city ||
					lab.city.match(re) ||
					branch
				) {
					return true;
				}

				return false;

			},
			searchLab(lab) {

				let self = this;

				if (self.name) {

					let re = new RegExp(self.name, 'gi');

					if (lab.name.match(re)) {
						return true;
					}

				} else {
					return true;
				}

				return false;

			},
			uniqueify(array) {
				var seen = {};
				return array.filter(function (item) {
					return seen.hasOwnProperty(item) ? false : (seen[item] = true);
				});
			},
			pageNumberClick(page) {
				this.currentPage = page - 1
				this.currentPageDummy = this.currentPage
				this.updateVisibleCards()
				this.updateVisiblePages()
				this.scrollToTop();
			},
			prevClick() {
				let self = this
				this.scrollToTop();
				if (self.currentPage >= 1) {
					self.currentPage--;
					this.currentPageDummy = this.currentPage;
					self.updateVisibleCards();
					self.updateVisiblePages();
					
				}
			},
			nextClick() {
				let self = this
				this.scrollToTop();
				if (self.currentPage < (self.pageCount - 1)) {
					self.currentPage++
					this.currentPageDummy = this.currentPage
					self.updateVisibleCards()
					self.updateVisiblePages();
				}
			},
			pageJumpBack() {
				this.currentPageDummy = (this.currentPageDummy - 5)
				this.updateVisiblePages()
			},
			pageJumpForward() {
				this.currentPageDummy = (this.currentPageDummy + 5)
				this.updateVisiblePages()
			},
			toggleInfo: function (marker, key) {
				let self = this;
				self.infoPosition = marker.map;
				self.infoName = marker.name;
				self.infoAddress = marker.address;
				setTimeout(() => {
					if (self.infoCurrentKey == key) {
						self.infoOpened = !self.infoOpened
					} else {
						self.infoOpened = true
						self.infoCurrentKey = key
					}
				}, 100)
			},
		},

	});

	if ($('#vue-member-labs-app').length) {

		new Vue({
			router,
			el: '#vue-member-labs-app'
		});

	}

})(window, jQuery);
